module.exports = __webpack_public_path__ + "static/media/studio NF3.cf99da06.jpg";